import { render, staticRenderFns } from "./sum-meal-card.vue?vue&type=template&id=2adbdafc&scoped=true&"
import script from "./sum-meal-card.vue?vue&type=script&lang=js&"
export * from "./sum-meal-card.vue?vue&type=script&lang=js&"
import style0 from "./sum-meal-card.vue?vue&type=style&index=0&id=2adbdafc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adbdafc",
  null
  
)

export default component.exports